import axios from 'axios'
import {asResponse} from '../util'

export const leaveAccount = async (account) => {
  const resp = await asResponse(axios.post('/bff/users/remove-from-account', {accountId: account.id}))
  return resp.data
}

export const closeAccount = async (accountId) => {
  await axios.post('/bff/accounts/close', {accountId})
}

export const regenerateApiKey = async (accountId) => {
  await axios.post('/bff/accounts/regenerate-api-key', {accountId})
}

export const ACCOUNTS_SWR_KEY = '/bff/accounts?load=startedByUser&limit=5000&sort={"stats.userCount": -1}'

export const getAccounts = async (url) => {
  const resp = await asResponse(axios.get(url))
  const accounts = resp.data ? (resp.data.results || []) : []
  return {
    accounts
  }
}
